import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminNavLink() {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    setIsActive(location.pathname);
  }, [location.pathname]);
  return (
    <>
      <Link
        to={"/admin/dashboard"}
        className={`${isActive === "/admin/dashboard" && "font-bold"}`}
      >
        Dashboard
      </Link>
      <Link
        to={"/admin/videos"}
        className={`${isActive === "/admin/videos" && "font-bold"}`}
      >
        Videos
      </Link>
      <Link
        to={"/admin/assignments"}
        className={`${isActive === "/admin/assignments" && "font-bold"}`}
      >
        Assignments
      </Link>
      <Link
        to={"/admin/assignmentMark"}
        className={`${isActive === "/admin/assignmentMark" && "font-bold"}`}
      >
        Assignments Mark
      </Link>
      <Link
        to={"/admin/quizzes"}
        className={`${isActive === "/admin/quizzes" && "font-bold"}`}
      >
        Quizzes
      </Link>
    </>
  );
}
